import { useNavigate } from 'react-router-dom'
import DeckFormContent from '../components/admin/DeckFormContent.jsx'

export default function NewDeckPage({ navBase = '/host/decks' }) {
  const navigate = useNavigate()

  return (
    <div className="min-h-[100dvh] bg-gray-900 flex flex-col">
      <header className="sticky top-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-white/10 px-4 py-3 flex items-center gap-3 shrink-0">
        <button
          onClick={() => navigate(navBase)}
          className="text-white/70 hover:text-white transition p-1 rounded-lg hover:bg-white/10 shrink-0"
          aria-label="Retour"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <img src="/android-chrome-192x192.png" alt="KartQuiz" className="w-7 h-7 rounded-lg shrink-0" />
        <span className="font-semibold text-white">Nouveau quiz</span>
      </header>

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-xl mx-auto px-4 py-8">
          <DeckFormContent navBase={navBase} />
        </div>
      </main>
    </div>
  )
}
